import { render, staticRenderFns } from "./SchoolChartDetail.vue?vue&type=template&id=dbd50cdc&"
import script from "./SchoolChartDetail.vue?vue&type=script&lang=js&"
export * from "./SchoolChartDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports